import { configureStore } from '@reduxjs/toolkit';
import loginState from './LoginRegister/reducers/loginState';
import navigationState from './Navigation/currentPage';
import competitionTabState from './Navigation/currentTab';
import entryState from './Competition/reducers/entryState';
import competitionCategories from './Competition/reducers/competitionCategories';
import pageState from './Navigation/currentPageState';
import competitionDetail from './Competition/reducers/competitionDetail';
import institutions from './Competition/reducers/institurions';
import genreLookup from './Competition/reducers/genreLookup';

export const store = configureStore({
  reducer: {
    loginState,
    navigationState,
    competitionTabState,
    entryState,
    competitionCategories,
    pageState,
    competitionDetail,
    institutions,
    genreLookup
  }
});